var _g, _path, _ellipse, _ellipse2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCardTwoIndicator(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 64,
    viewBox: "0 0 58 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2223_174)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 10C0 5.28595 0 2.92893 1.46447 1.46447C2.92893 0 5.28595 0 10 0H29C37.381 0 41.5715 0 44.9223 1.23617C50.4116 3.26125 54.7387 7.58844 56.7638 13.0777C58 16.4285 58 20.619 58 29V29C58 37.381 58 41.5715 56.7638 44.9223C54.7387 50.4116 50.4116 54.7387 44.9223 56.7638C41.5715 58 37.381 58 29 58H10C5.28595 58 2.92893 58 1.46447 56.5355C0 55.0711 0 52.714 0 48V10Z",
    fill: "#A6CD25"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.8541 45.396C14.7821 45.396 12.4301 44.256 10.7981 41.976C9.19006 39.672 8.38606 36.42 8.38606 32.22C8.38606 29.412 8.74606 27.048 9.46606 25.128C10.2101 23.184 11.2781 21.72 12.6701 20.736C14.0861 19.728 15.8141 19.224 17.8541 19.224C20.9501 19.224 23.3021 20.34 24.9101 22.572C26.5181 24.78 27.3221 27.996 27.3221 32.22C27.3221 35.028 26.9501 37.416 26.2061 39.384C25.4861 41.328 24.4301 42.816 23.0381 43.848C21.6461 44.88 19.9181 45.396 17.8541 45.396ZM17.8541 40.86C19.2461 40.86 20.2781 40.176 20.9501 38.808C21.6221 37.416 21.9581 35.22 21.9581 32.22C21.9581 29.22 21.6221 27.06 20.9501 25.74C20.2781 24.42 19.2461 23.76 17.8541 23.76C16.4621 23.76 15.4301 24.42 14.7581 25.74C14.0861 27.06 13.7501 29.22 13.7501 32.22C13.7501 35.22 14.0861 37.416 14.7581 38.808C15.4301 40.176 16.4621 40.86 17.8541 40.86ZM34.328 45C33.44 45 32.78 44.796 32.348 44.388C31.94 43.956 31.736 43.332 31.736 42.516C31.736 41.988 31.868 41.496 32.132 41.04C32.396 40.584 32.756 40.116 33.212 39.636L39.98 32.508C40.988 31.428 41.708 30.468 42.14 29.628C42.596 28.788 42.824 27.948 42.824 27.108C42.824 26.052 42.476 25.248 41.78 24.696C41.108 24.144 40.124 23.868 38.828 23.868C38.132 23.868 37.412 23.976 36.668 24.192C35.948 24.384 35.192 24.708 34.4 25.164C33.872 25.452 33.38 25.56 32.924 25.488C32.492 25.392 32.12 25.188 31.808 24.876C31.496 24.54 31.292 24.144 31.196 23.688C31.1 23.232 31.148 22.776 31.34 22.32C31.532 21.864 31.892 21.48 32.42 21.168C33.476 20.52 34.628 20.04 35.876 19.728C37.124 19.392 38.36 19.224 39.584 19.224C41.48 19.224 43.076 19.512 44.372 20.088C45.668 20.64 46.652 21.456 47.324 22.536C47.996 23.616 48.332 24.936 48.332 26.496C48.332 27.504 48.176 28.488 47.864 29.448C47.552 30.408 47.06 31.38 46.388 32.364C45.74 33.324 44.876 34.356 43.796 35.46L37.496 41.868V40.428H47.252C48.02 40.428 48.596 40.62 48.98 41.004C49.388 41.388 49.592 41.952 49.592 42.696C49.592 43.44 49.388 44.016 48.98 44.424C48.596 44.808 48.02 45 47.252 45H34.328Z",
    fill: "#FFFEFF"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 46.0227,
    cy: 10.5,
    rx: 7.60186,
    ry: 2.95423,
    transform: "rotate(31.6062 46.0227 10.5)",
    fill: "white"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 6.59497,
    cy: 51.5551,
    rx: 4.07411,
    ry: 2.17568,
    transform: "rotate(22.2251 6.59497 51.5551)",
    fill: "white",
    fillOpacity: 0.91
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2223_174",
    x: 0,
    y: 0,
    width: 58,
    height: 63.5172,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5.51724
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.546416 0 0 0 0 0.676822 0 0 0 0 0.115072 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2223_174"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2223_174",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardTwoIndicator);
export default __webpack_public_path__ + "static/media/card-two-indicator.5e484e6ea51ca7bad962f33dc33f143f.svg";
export { ForwardRef as ReactComponent };